<template>
  <div>
    <v-toolbar>
       <v-btn
          color="secondary"
          :loading="documentWriting"
          @click="saveLabels()"
          icon
        >
          <v-icon v-once>mdi-content-save</v-icon>
        </v-btn>
        <v-btn
            icon
            color="secondary"
            @click="enter()"
        >
          <v-icon v-once>mdi-keyboard-return</v-icon>
        </v-btn>
        
        <v-btn icon
               v-if="currentDocuments.length>0" 
               :loading="loading_previous" 
               color="secondary" 
               :disabled="currentIndex<=0 && !currentPagination.previous" 
               @click="previous_document()">
          <v-icon v-once>mdi-arrow-left</v-icon>
        </v-btn>

        <v-btn icon
               v-if="currentDocuments.length>0"
               :loading="loading_next" 
               color="secondary" 
               :disabled="currentIndex>=currentDocuments.length-1 && !currentPagination.next" 
               @click="next_document()">
          <v-icon v-once>mdi-arrow-right</v-icon>
        </v-btn>

        <v-btn color="secondary" :loading="flowLoading" @click="continueFlow()">Continuar</v-btn>
    </v-toolbar>

    <div>
      <v-row>
        <v-col cols="3"  class="pr-0">
          <v-btn v-if="userData.can_debug_documents" color="secondary" @click="changeDrawerMode()"><v-icon>mdi-autorenew</v-icon></v-btn>
        </v-col>
        <v-col cols="9" class="pr-0">
          <v-list-item-title class="title">Modo entrenamiento</v-list-item-title>
        </v-col>
      </v-row>
    </div>

    <v-container>

      <v-row no-gutters>
        <v-col cols="3" class="pr-0">
          <v-select
            :items="[{id:'human', text:'Human'},{id:'human_payroll', text:'Human Payroll'}, {id:'machine', text:'Machine'}]"
            v-model="annotationLayer"
            item-text="text" item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="8" offset="1">
          <v-select :items="docStates" v-if="currentDocument" v-model="currentDocument.state" label="State">
          </v-select>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <v-select
            multiple
            :items="tags"
            v-if="currentDocument"
            item-text="name"
            item-value="value"
            v-model="currentDocument.tags"
            label="Tags"
          ></v-select>
        </v-col>
      </v-row>

    </v-container>
   

    <v-divider></v-divider>

    <TrainerTagsInfo></TrainerTagsInfo>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item>
        <v-textarea
          v-if="currentDocument" 
          label="Comment"
          v-model="currentDocument.comment"
        ></v-textarea>
      </v-list-item>
    </v-list>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { client } from "@/api/client";
import { user as api_user } from "@/api/user";
import { mapFields } from 'vuex-map-fields';
import {mapFieldsMetadata,vuexPrefix} from "../store/vuex_utils"
import TrainerTagsInfo from './TrainerTagsInfo.vue'

export default {
  name: "RightDrawerTrainerMode",
  components: {
    TrainerTagsInfo
  },
  data() {
    return {
      classification:'human',
      loading_previous: false,
      loading_next: false,
    
    }
  },
  computed: {
    ...mapGetters(['docStates']),
    ...mapGetters({
      availableTags: "availableTags",
      annotationLayer: "documents/annotationLayer",
      creatingMoves: "accounts/creatingMoves",
      flowLoading: "documents/flowLoading",
      documentWriting: "documents/documentWriting",
      currentDocument: "documents/currentDocument",
      selectedLabel: "documents/selectedLabel",
      selectedTextPayload: "documents/selectedTextPayload",
      currentDocumentData: "documents/currentDocumentData",
      currentDocuments: "documents/currentDocuments",
      currentIndex: "documents/currentIndex",
      currentPagination: "documents/currentPagination",
      docState: "documents/docState",
      tags: "get_tags",
      suppliers: "get_suppliers",
      customers: "get_customers",
      userData: 'me/userData',
      documentIsTrainerMode: 'documents/documentIsTrainerMode'
    }),
    ...mapFields('documents',vuexPrefix('document_',['kind','state','supplierdb','customerdb'],'document.')),
    ...mapFields('documents',['annotationLayer', 'documentIsDebuggerMode']),

  },
  methods: {
    enter() {
      this.saveLabels({ and_go_back_to: "/documents" });
    },
    previous_document(){
      this.loading_previous=true
      if(this.currentIndex>=1) {
        var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex-1].id.toString() } };
        this.selectLabel({ label: null });
        this.$router.push(params);
        this.fetchDocument({ id: this.currentDocuments[this.currentIndex-1].id }).then(() => {
          this.loading_previous=false
        })
        this.setCurrentIndex(this.currentIndex-1)
      }
      else {
        let url_split=this.currentPagination.previous.split('/api')
        let url = url_split[url_split.length-1]
        client.get(url).then(response => {
          this.setCurrentDocs(response.data)
          let ind = response.data.results.length-1
          this.setCurrentIndex(ind)
          var params = { name: "document-detail", params: { document: this.currentDocuments[ind].id.toString() } };
          this.selectLabel({ label: null });
          this.$router.push(params);
          this.fetchDocument({ id: this.currentDocuments[ind].id }).then(() => {
            this.loading_previous=false
          })
        });
      }
    },
    next_document(){
      this.loading_next=true
      if(this.currentIndex+1<=this.currentDocuments.length-1){
        var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex+1].id.toString() } };
        this.selectLabel({ label: null });
        this.$router.push(params);
        this.fetchDocument({ id: this.currentDocuments[this.currentIndex+1].id }).then(() => {
          this.loading_next=false
        })
        this.setCurrentIndex(this.currentIndex+1)
      }
      else{
        let url_split=this.currentPagination.next.split('/api')
        let url = url_split[url_split.length-1]
        client.get(url).then(response => {
          this.setCurrentDocs(response.data)
          this.setCurrentIndex(0)
          var params = { name: "document-detail", params: { document: this.currentDocuments[0].id.toString() } };
          this.selectLabel({ label: null });
          this.$router.push(params);
          this.fetchDocument({ id: this.currentDocuments[0].id }).then(() => {
            this.loading_next=false
          })
        });
      }
      
    },
    changeDrawerMode() {
      // this.setIsTrainerMode(!this.documentIsTrainerMode);
      this.documentIsDebuggerMode = !this.documentIsDebuggerMode;
    },
    ...mapActions({
      createMoveLines: "accounts/createMoveLines",
      continueFlow: "documents/continueFlow",
      deleteLabel: "documents/deleteLabel",
      selectLabel: "documents/selectLabel",
      saveLabels: "documents/saveLabels",
      setCurrentIndex: "documents/setCurrentIndex",
      fetchDocument: "documents/fetchDocument",
      setCurrentDocs: "documents/setCurrentDocs",
      setIsTrainerMode: "documents/setIsTrainerMode",
    }),
  },
};
</script>

<style scoped>
.selected-chevron {
  margin-right: 0.5em;
}
</style>
